var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLightbulbmin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0060DF",
    d: "M12 22q-.65 0-1.175-.312A2.3 2.3 0 0 1 10 20.85q-.825 0-1.412-.588A1.93 1.93 0 0 1 8 18.85V15.3a7.24 7.24 0 0 1-2.362-2.575A7.05 7.05 0 0 1 4.75 9.25q0-3.026 2.113-5.137Q8.974 2 12 2q3.026 0 5.137 2.113Q19.25 6.225 19.25 9.25q0 1.925-.887 3.5A7.3 7.3 0 0 1 16 15.3v3.55q0 .825-.588 1.412A1.93 1.93 0 0 1 14 20.85 2.27 2.27 0 0 1 12 22m-2-3.15h4v-.9h-4zm0-1.9h4V16h-4zM9.8 14h1.45v-2.7l-2.2-2.2 1.05-1.05 1.9 1.9 1.9-1.9 1.05 1.05-2.2 2.2V14h1.45a5.5 5.5 0 0 0 2.2-1.912q.85-1.263.85-2.838 0-2.2-1.525-3.725T12 4 8.275 5.525 6.75 9.25q0 1.575.85 2.838Q8.45 13.35 9.8 14"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLightbulbmin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_lightbulb.min.fe092b8d361d8132ae148e15ed4f4191.svg";